import React from 'react';
import { motion } from 'framer-motion';
import { ArrowDown } from 'lucide-react';
import AngelScene from './AngelScene';

export default function HeroSection() {
  return (
    <section id="hero" className="relative min-h-screen flex items-center justify-center overflow-hidden" data-testid="hero-section">
      {/* 3D Background */}
      <div className="canvas-container">
        <AngelScene />
      </div>

      {/* Content Overlay */}
      <div className="relative z-10 text-center px-8 sm:px-6 max-w-5xl mx-auto w-full overflow-hidden">
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.3, duration: 1 }}
          className="font-mono text-[9px] sm:text-xs tracking-[0.25em] sm:tracking-[0.4em] text-white/40 mb-6 sm:mb-8"
          data-testid="hero-subtitle"
        >
          AI-POWERED 3D AGENCY
        </motion.p>

        <motion.h1
          initial={{ opacity: 0, y: 60 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.5, duration: 1, ease: [0.16, 1, 0.3, 1] }}
          className="font-heading text-4xl sm:text-6xl lg:text-8xl leading-[0.9] mb-6 sm:mb-8"
          data-testid="hero-title"
        >
          CELESTIAL
          <br />
          <span className="text-white/20 text-3xl sm:text-6xl lg:text-8xl">CREATIONS</span>
        </motion.h1>

        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.9, duration: 1 }}
          className="font-heading text-[9px] sm:text-xs md:text-sm uppercase tracking-normal sm:tracking-wide text-white max-w-md sm:max-w-xl mx-auto mb-8 sm:mb-12 leading-relaxed font-normal px-2"
          data-testid="hero-description"
        >
          WE CRAFT CUSTOM ELITE 3D PIECES FOR BRANDS THAT REFUSE TO BE ORDINARY.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 1.2, duration: 0.8 }}
          className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4"
        >
          <a href="https://calendly.com/archangelworks1/30min" target="_blank" rel="noopener noreferrer" className="btn-primary text-xs sm:text-sm px-6 sm:px-10 py-3 sm:py-4" data-testid="hero-cta-button">
            Book a Free Consultation
          </a>
          <a href="#portfolio" className="btn-outline text-[10px] sm:text-xs px-5 sm:px-9 py-2.5 sm:py-3.5" data-testid="hero-work-button">
            View Our Work
          </a>
        </motion.div>
      </div>

      {/* Scroll Indicator */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 2, duration: 1 }}
        className="absolute bottom-10 left-1/2 -translate-x-1/2 z-10"
      >
        <motion.div
          animate={{ y: [0, 10, 0] }}
          transition={{ duration: 2, repeat: Infinity }}
        >
          <ArrowDown size={20} className="text-white/20" />
        </motion.div>
      </motion.div>
    </section>
  );
}
